<template>
    <x-data-table
        v-if="showOfferedLine"
        :headers="headers"
        class="no-row-hover double-rows double-dashed-rows cell-vertical-align-top cell-padding-vertical"
        :items="firmOrderLines"
        hide-actions
    >
        <template v-slot:items="props">
            <tr>
                <td>
                    {{ props.item.captive_insurer_company_id ? props.item.captive_insurer_company.name :props.item.insurer_company.name }}
                    <template v-if="props.item.underwriter_reference"><br>Reference: {{ props.item.underwriter_reference }}</template>
                    <template v-if="props.item.risk_code"><br>Risk code: {{ props.item.risk_code }}</template>
                    <template v-if="props.item.insurer_role"><br>Role: {{ props.item.insurer_role }}</template>
                </td>
                <td class="text-xs-right">
                    <template v-if="props.item.brokerage">{{ props.item.brokerage | percent }}</template>
                    <template v-else>-</template>
                </td>
                <td class="text-xs-right">
                    {{ props.item.written_line_amount | currency(submission.currency.code) }}
                    <br>
                    <x-tooltip bottom>
                        <template v-slot:activator="{ on }">
                                <span v-on="on">
                                    {{ props.item.written_line_percent_display | percent(4) }}
                                </span>
                        </template>

                        <span>{{ props.item.written_line_percent | percent(12) }}</span>
                    </x-tooltip>
                </td>
                <td class="text-xs-right">
                    <template v-if="props.item.price">
                        {{ props.item.price }} BPS
                        <template v-if="props.item.percentage_of_margin"><br>({{ props.item.percentage_of_margin | percent }} of {{ typeOfMargin(props.item.offer.type) }} margin)</template>
                    </template>
                    <template v-else-if="props.item.flat_fee">
                        {{ props.item.flat_fee | currency(submission.currency.code) }}
                    </template>
                    <template v-else>-</template>
                </td>
                <td class="text-xs-right">
                    {{ firmOrder.waiting_period }} days
                </td>
                <td class="text-xs-right" v-if="firmOrderHasWaitingPeriodInterest">
                    <x-tooltip top>
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                {{ props.item.maximum_insured_exposure | currency(submission.currency.code) }}
                            </div>
                        </template>
                        <p>
                            Written line: {{ props.item.written_line_amount | currency(submission.currency.code) }}
                        </p>
                        <p>
                            Interest rate: {{ props.item.firm_order.waiting_period_interest_rate | percent }}
                        </p>
                        <p>
                            Waiting period interest: {{ props.item.waiting_period_interest | currency(submission.currency.code) }}
                        </p>
                        <p>
                            Total: {{ props.item.maximum_insured_exposure | currency(submission.currency.code) }}
                        </p>
                    </x-tooltip>
                </td>
            </tr>
            <tr>
                <td class="note-cell" :colspan="colspan">
                    <span v-if="getSecurityName(props.item.security)">Security: {{ getSecurityName(props.item.security) }}</span>
                </td>
            </tr>
        </template>
    </x-data-table>
</template>

<script>
    import waitingPeriodInterest from '~/mixins/waitingPeriodInterest';

    export default {
        name: "FirmOrderSummary",
        props: {
            submission: Object,
        },
        data() {
            return {
                accepting: false,
                profile: {},
                pagination: {
                    sortBy: 'price',
                    descending: true,
                    rowsPerPage: -1
                },
            }
        },
        computed: {
            headers() {
                const headers = [
                    {
                        text: 'insurer / security',
                        value: 'insurer_company.name'
                    },
                    {
                        text: 'brokerage',
                        value: 'offer.brokerage',
                        align: 'right'
                    },
                    {
                        text: 'written line',
                        value: 'written_line_amount',
                        align: 'right'
                    },
                    {
                        text: 'premium rate',
                        align: 'right'
                    },
                    {
                        text: 'waiting period',
                        value: 'waiting_period',
                        align: 'right'
                    },
                ];

                if (this.firmOrderHasWaitingPeriodInterest) {
                    headers.push({
                        text: 'maximum insured exposure',
                        value: 'max_insured_exposure',
                        align: 'right',
                    });
                }

                return headers;
            },
            firmOrder: function() {
                return this.submission.firm_orders.find(order => order.status !== 'cancelled') || {};
            },
            offeredLine: function () {
                return this.firmOrder.firm_order_offers || {};
            },
            firmOrderLines: function () {
                // @TODO filter by user/company logged in
                let firmOrder = this.submission.firm_orders.find(order => ['reviewing', 'captive_reviewing'].includes(order.status)) || {};
                return firmOrder.firm_order_offers.filter(offer => ['firm_order', 'accepted', 'captive_reviewing'].includes(offer.status)) || {};
            },
            showOfferedLine: function () {
                return Object.keys(this.firmOrderLines).length > 0;
            },
            firmOrderHasWaitingPeriodInterest() {
                return this.submission.facility && waitingPeriodInterest.submissionHasWaitingPeriodInterest(this.submission.facility.waiting_period_interest);
            },
            colspan() {
                return (this.firmOrderHasWaitingPeriodInterest) ? 7 : 6;
            }
        },
        created() {
            this.profile = this.$root.user;
        },
        methods: {
            getSecurityName: function (security) {
                return security !== null ? security.name : '';
            },
            typeOfMargin(type) {
                if (type === 'percentage_of_net_margin') {
                    return 'net';
                } else if (type === 'percentage_of_gross_margin') {
                    return 'gross';
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .x-table.x-datatable tbody tr td.note-cell {
        height: auto;
        padding-top: 0;
        padding-bottom: 0;

        > span {
            display: inline-block;
            padding-bottom: 8px;
        }
    }
</style>
